/**
 * Copyright (c) 2023, Mohamed eRrais
 * merrais@tech2us.ma
 * https://akademy.ma, https://digitalservices.ma, https://app.2us.ma, https://tech2us.ma
 * محمد الرايس
 * Tech2us
 * meLayout.js
*/

//Variables declared with var are function-scoped or globally scoped. let and const are block-scoped.
import './meLayout.css'
import Api, {Fetch} from './Api'

var curating = false
var splitting = false
var resizing = false // table.header.cells (column order) used to resize column!

function Etat(message) {
	if(message) {
		const etat = document.getElementById("etat")
		if(etat) {
			etat.innerHTML = "<p>"+message+"</p>"
			if(message.includes('?')){
				etat.style.color='darkred'
			}
			else if(message.includes('!')){
				etat.style.color='darkgreen'
			}
			else if(message.includes('.')){
				etat.style.color='darkblue'
			}
			else {
				etat.style.color='black'
			}
		}
	}
}

function OnEdit(item, event, role) {
	if(item) {
		//console.log(curating, this.category, item, event) ;alert('Edit '+item.value)
		if(!curating) {
			if(role && role>=3) {
				//	alert('Edit '+role)

				item.readOnly = !item.readOnly
				if(item.readOnly) {
					item.style.cursor = 'default'
				}
				else {
					item.style.cursor = 'text'
					//item.focus()
					let l = item.value.length
					item.setSelectionRange(l, l)
				}
			}
			else
				item.readOnly=true
		}
		else {
			item.readOnly = !item.readOnly
			if( ['Choice','Clip'].includes(this.category)) {
				Etat(`Edit ${item.readOnly} - ${item.value}`) //;alert(item.value)
			}
			else {
				if(item.readOnly) {
					item.style.cursor = 'default'
					item.style.border = 'none'
					//item.title = 'Reading'
				}
				else if(this.category!=="Picture") {
					item.style.cursor = 'text'
					item.style.border = '1px solid lightblue'
				}
			}	
			
			if(event) {
				event.stopPropagation()
			}	
		}
	}
}

	
/**
 * MeR meComponent items
 * category in {"Comment", "Picture", "Capture", "PostIt"} 
 */
	
export class meComponent {
	constructor(category) {
		this.category = category;
		this.area = null;
		this.size = {w:window.innerWidth, h:window.innerHeight}
		this.track = `${Api.defaults.baseURL}/${category}Layout`
		this.Reset()
	}

	Reset() {
		this.items = [] 
		this.selected = -1
		this.moved=false
		this.clic = {x:0, y:0}	
		//alert("meComponent Reset")
	}


	isIn(x, y, bcr) {
		return (
			(x >= bcr.left) && (x <= bcr.right) &&  (y >= bcr.top) &&  (y <= bcr.bottom) 
		)
	}

	clicIn(bcr) {
		if(bcr)
			return this.isIn(this.clic.x, this.clic.y, bcr) 
	}

	mouseIn(event,bcr) {
		return this.isIn(event.clientX, event.clientY, bcr) 
	}

	getId(item) {
		return (item?.id) ? item.id.replace(this.category, "") : 0
	}

	Coord(bcr, parent) {
		if(bcr) {
			let x = parseFloat(bcr.left*100/this.size.w).toFixed(2)
			let y = parseFloat(bcr.top*100/this.size.h).toFixed(2)
			let w = parseFloat(bcr.width*100/this.size.w).toFixed(2)
			let h = parseFloat(bcr.height*100/this.size.h).toFixed(2)
			if(parent) {
				let pbcr = parent.getBoundingClientRect()
				x = parseFloat((bcr.left-pbcr.left)*100/pbcr.width).toFixed(2)
				y = parseFloat((bcr.top-pbcr.top)*100/pbcr.height).toFixed(2)
				w = parseFloat(bcr.width*100/pbcr.width).toFixed(2)
				h = parseFloat(bcr.height*100/pbcr.height).toFixed(2)	
			}
			return `${x},${y},${w},${h}`
		}
	}

	toCoord(left,top,width,height) {
		let x = parseFloat(left*100/this.size.w).toFixed(2)
		let y = parseFloat(top*100/this.size.h).toFixed(2)
		let w = parseFloat(width*100/this.size.w).toFixed(2)
		let h = parseFloat(height*100/this.size.h).toFixed(2)
		return `${x},${y},${w},${h}`
	}

	Pc(value, size) {
		return Math.round(value*100/size)+'%'
	}

	Px(value, size) {
		return Math.round(value*size/100)+'px'
	}
	
	AppendChild(element, id, coord) {
		let ps = coord?.split(',')
		if(ps?.length===4) {
			var div = document.getElementById(id)
			if(div==null) {
				div = document.createElement('div')
				div.id = id
				div.className=this.category
				div.style.position = 'fixed'
				div.style.border = '0px solid gray'
	
				element.appendChild(div);
			}

			div.style.left = this.Px(ps[0],this.size.w) 
			div.style.top = this.Px(ps[1],this.size.h)
			div.style.width = this.Px(ps[2],this.size.w) 
			div.style.height = this.Px(ps[3],this.size.h) 

			div = document.getElementById(id)
			return div
		}
	}

	SetCoord(element, coord) {
		if(element) {
			let ps = coord?.split(',')
			if(ps?.length===4) {
				element.style.left = this.Px(ps[0],this.size.w) 
				element.style.top = this.Px(ps[1],this.size.h)
				element.style.width = this.Px(ps[2],this.size.w) 
				element.style.height = this.Px(ps[3],this.size.h) 
			}
		}
	}

	SetColor(element, color) {
		if(color) {
			if(color.Back?.length>0)
				element.style.backgroundColor = `rgba(${color.Back})`
			if(color.Font?.length>0)
				element.style.color = `rgba(${color.Font})` 
			if(color.Bord?.length>0)
				element.style.borderColor = `rgba(${color.Bord})`
		}
	}

	SetFont(element, font) {
		if(font) {
			if(font.Family?.length>0)
				element.style.fontFamily = font.Family

			if(font.Size?.length>0)
				element.style.fontSize = `${font.Size}rem` 

			if(font.Weight?.length>0)
				element.style.fontWeight = font.Weight
			
			if(font.Style?.length>0)
				element.style.fontStyle = font.Style 
		}
	}
	
	selectorAll() {
		this.items = []
		this.items = document.querySelectorAll(`[id^=${this.category}]`)
		//alert(this.items.length)
		this.selected=-1
	}

	mouseInit(event) {
		this.clic = {x:event.clientX, y:event.clientY}
		this.hovered=-1
		this.selected=-1
		this.moved=false
	}

	mouseDown(event) {
		//	alert(`Component.Down ${event.target.value}`)
		if(this.selected>-1)
			this.items[this.selected].style.border = "none"

		this.mouseInit(event)
		this.selectorAll()

		for (let i = 0; i < this.items.length; i++) {
			let id=this.items[i].id.replace(this.category, "")
			if(parseInt(id)>0) {
				let bcr = this.items[i].getBoundingClientRect()
				if( this.clicIn(bcr) ) {
					this.selected=i
					this.items[i].style.border = "1px solid blue"
					//alert(i)
					event.stopPropagation()
					break
				}
			}
		}        
	}

	mouseMove(event) {
		if(event.buttons === 1) {
			if(this.selected>-1) {

				const l = (event.clientX - this.clic.x) ;
				const h = (event.clientY - this.clic.y) ;

				//alert(`${l} ${h}`)
				if(this.Moving(l, h)) {
					
					this.clic = {x:event.clientX, y:event.clientY}
					this.moved=true
				}
				event.stopPropagation()
			}				
		}
		else {
			this.Bounding(event)
		}
	}

	Bounding(event){
		let cursor="default"
		this.items.forEach((item) => {
			
			let bcr = item.getBoundingClientRect()
			if( this.mouseIn(event, bcr) )
			{
				const delta = 6 //Math.round()
				cursor = "pointer"
				if( (bcr.bottom - event.clientY < delta) && (bcr.right - event.clientX < delta) )
				{
					cursor = "se-resize" 
				}
				else if(event.clientX - bcr.left < delta)
					cursor = "w-resize";
				else if(event.clientY - bcr.top < delta)
					cursor = "n-resize";
				else if(bcr.right - event.clientX < delta)
					cursor = "e-resize";
				else if(bcr.bottom - event.clientY < delta)
					cursor = "s-resize";
				
				item.style.cursor = cursor

				Etat(`${cursor} - ${item.id} : ${event.clientX},${event.clientY} - ${bcr.left},${bcr.top},${bcr.right},${bcr.bottom}`)
			}
		})
	}

	Moving(l, h)
	{
		var item = this.items[this.selected]
		if(item && (l!==0 || h!==0)) {
			let bcr = item.getBoundingClientRect()
			if(bcr) {
				switch(item.style.cursor)
				{
				case "w-resize":
					item.style.left = (bcr.left + l) + 'px'
					item.style.width = (bcr.width - l) + 'px'
					break;
					
				case "n-resize":
					item.style.top = (bcr.top + h) + 'px'
					item.style.height = (bcr.height - h) + 'px'
					break;
				
				case "e-resize":
					item.style.width = (bcr.width + l) + 'px'
				break;
				
				case "s-resize":
					item.style.height = (bcr.height + h) + 'px'
				break;
				
				case "se-resize":
					item.style.width = (bcr.width + l) + 'px'
					item.style.height = (bcr.height + h) + 'px'
				break;
				
				case "pointer":
				default:
					item.style.left = (bcr.left + l) + 'px'
					item.style.top = (bcr.top + h) + 'px'
					break;
				}
				return true
			}
		}
	}

	Tracking(element) {
		if( this.selected>=0 && this.moved && element) {
			let bcr = element.getBoundingClientRect()
			let coord = this.Coord(bcr)

			let id=element.id.replace(this.category, "")
			const data = {action:`Move`, id:id,  coord:coord} //alert(data); Etat(`Tracking ${this.selected} data ${data}`)
			
			Fetch(`/Layout`, data, element, 'PUT')
		}
	}

	PutCoord(item, relative=false) {
		if(item?.parentElement) {
			let component = item.parentElement.getAttribute("id")
			let element = item.getAttribute("id")

			let bcr = item.getBoundingClientRect()
			let coord = this.Coord(bcr)
			if(relative)
				coord = this.Coord(bcr,item.parentElement)

			const data = {action:'Coord', component, element, coord}
			
			//alert(JSON.stringify(data))
			Fetch(`/Layout`,data,item,'PUT')
		}
	}
	
	mouseUp(event) {
		if(this.selected>=0) {
			if(this.moved) {
				var element = this.items[this.selected] 

				//alert("Why ?")
				this.Tracking(element)
				//event.stopPropagation()
			}
			this.mouseInit(event)
		}
	}

	keyUp(event) {
		if(event?.code?.startsWith('Arrow')) {

			var element = this.items[this.selected]
			if(element) {
				let bcr = element.getBoundingClientRect()
				if(bcr){
					this.moved=false
					let step=1
					let w = Math.round(step*this.size.w/100)
					let h = Math.round(step*this.size.h/100)
					switch(event.code){
						case "ArrowUp":{ 							
							
							if(bcr.top >= h){
								element.style.top = (bcr.top - h) + 'px'
								this.moved=true
							}
							break;
						}
						case "ArrowDown":{ 
							if(bcr.top<this.size.h){
								element.style.top = (bcr.top + h) + 'px'
								this.moved=true
							}
			
							break;
						}
						case "ArrowLeft":{ 
							if(bcr.left>=w){
								element.style.left = (bcr.left - w) + 'px'
								this.moved=true
							}
			
							break;
						}
						case "ArrowRight":{ 
							if(bcr.left<this.size.w){
								element.style.left = (bcr.left + w) + 'px'
								this.moved=true
							}
			
							break;
						}
						default:
							return
					}
					this.Tracking(element)
				}
			}
		}
	}

	onEdit() {
		if(this.items.length===0)
			this.selectorAll()

		//alert(`onEdit ${this.items.length}`)
		const tag = (this.category==="Picture") ? "img" : "textarea"
		for (var i = 0; i < this.items.length; i++) {
			
			var content = this.items[i].getElementsByTagName(tag)[0]
			if(content) {
				OnEdit(content)
			}
		}
	}

    // Neutralized by by Bound and Move
    Linking(screen) {
        if(screen) {
            this.comments = document.querySelectorAll('[id^=Comment]')
            for (var i = 0; i < this.comments.length; i++) {
                screen.SetDIV(this.comments[i].id)
            }
            this.onEdit()
        }   
    }

	// MeR nice perform
	Historizing(field, value, entityId) {
		if(this.historizing.length>3) {
			//Historizing(this.historizing,`${this.category}s`,field, value, entityId)
		}
	}
}

/**
 * MeR 231115 1140
 */
export class meChoice extends meComponent {
	constructor(category='Choice', root=null, area=null ) {
		super(category)
		this.selecteds = []
		this.coords = []
		this.setArea(root, area)
	}

	setArea(root, area) {	
		this.root = root ? document.getElementById(root) : null
		
		this.parent = area ? document.getElementById(area) : null
		this.area = this.parent ? this.parent.getBoundingClientRect() : {left:1, top:1, width:window.innerWidth, height:window.innerHeight}
		
		this.size = {w:this.area.width, h:this.area.height}
	}

	// override methods 
	selectorAll() {
		this.items = []
		if(this.root){
			this.items = this.root.querySelectorAll(`[id^=${this.category}]`)
			this.items.forEach((item) => {
				this.selecteds.push(false)
			})
			//alert(this.items.length)
		}
	}

	SetCoord(element, coord) {
		let ps = coord?.split(',')
		if(this.area && ps?.length===4) {

			let x = Math.round(this.area.left + ps[0]*this.area.width/100)
			let y = Math.round(this.area.top + ps[1]*this.area.height/100)
			let w = Math.round(ps[2]*this.area.width/100)
			let h = Math.round(ps[3]*this.area.height/100)

			element.style.left = `${x}px`
			element.style.top = `${y}px`
			element.style.width = `${w}px`
			element.style.height = `${h}px` 
			return element
		}
	}
	
	AppendChild(id, coord) {

		if(this.root && coord?.length>4) {

			var div = document.getElementById(id)
			if(div==null) {
				div = document.createElement('div')
				div.id = id
				div.className=this.category
				div = this.root.appendChild(div);
				this.coords.push(coord)
				//console.log(div, this.root)
			}

			return this.SetCoord(div, coord)
		}
		else {
			console.log(`AppendChild ${id} ${coord} root ${this.root.id} ?`)
		}
	}

	MoveChild(event) {
		if(this.root && this.parent && this.items.length>0) {
			this.area = this.parent.getBoundingClientRect()
			if(this.area) {
				this.items.forEach((item, index) => {
					this.SetCoord(item, this.coords[index])
				})
			}
		}
	}

	Tracking(item, json=false) {
		if( this.selected>=0 && this.moved && item) {
			let bcr = item.getBoundingClientRect()

			let x = parseFloat((bcr.left-this.area.left)*100/this.area.width).toFixed(2)
			let y = parseFloat((bcr.top-this.area.top)*100/this.area.height).toFixed(2)
			let w = parseFloat(bcr.width*100/this.area.width).toFixed(2)
			let h = parseFloat(bcr.height*100/this.area.height).toFixed(2)

			let coord = `${x},${y},${w},${h}`

			let id=item.id.replace(this.category, "")
			if(json) {
				//alert(`${item.id}Id=${id} Coord=${coord}`)
				let data = {entity:'Clip', field:'Coord', id:id, value:coord}
				Fetch('/data', data, item, 'PUT')
				.then(res=>{
					const history = {...data, Entity:'HistoryField'}
					Fetch(`/data`, history, item)    // from TableView !                 
				})
			}
			else {
				let data = `action=${this.category}Move&${this.category}Id=${id}&Coord=${coord}`
				Fetch(this.track, data, item)
				this.Historizing('Coord', coord, id)
			}
			//Etat(`Tracking ${this.selected} data ${data}`); console.log(data); alert(data)
		}
	}

	mouseDown(event) {

		this.mouseInit(event)
		if(this.clicIn(this.area)) {
			this.selectorAll()
			this.selected=-1
			this.items.forEach((item,index)=>{
				const bcr = item.getBoundingClientRect()
				if(bcr) {
					//let content = item.getElementsByTagName('textarea')[0]
					if(this.clicIn(bcr)) {
						this.selected=index
						this.selecteds[index] = !this.selecteds[index];
						Etat(`${this.category} - ${this.selected} / ${this.items.length}`)
						//alert(this.selected)
					}
					
					if(this.selecteds[index]){
						item.style.borderWidth = '3px'
						item.style.borderImage = 'linear-gradient(to bottom right, #00b7eb, #0000cd) 1'
					}
					else {
						item.style.borderWidth = '1px'
						item.style.borderImage = 'linear-gradient(to bottom right, #7851a9, silver, #800080) 1'
					}
				}
			})
		}
	}

	mouseUp(event) {
		if(this.selected>=0) {
			if(this.moved) {
				var element = this.items[this.selected] 

				//alert("Why ?")
				this.Tracking(element, true)
				//event.stopPropagation()
			}
			this.mouseInit(event)
		}
	}

}


/**
 * MeR 231021
 */
export class meSplitter extends meComponent {
	constructor(category, root=null, vertical=true) {
		super(category)
		this.root = root
		this.entity = null
		this.width = 0
		this.hovered = -1
		this.coords = []
		this.vertical = vertical

		if(category?.length>1)
			this.selectorAll()
	}

	// MeR 250123
	SetCoord(element, coord) {
		if(element) {
			let ps = coord?.split(',')
			if(ps?.length===4) {
				if(this.vertical) {
					element.style.width =  `${ps[2]}%` //this.Px(ps[2],this.size.w) // 
				}
				else {
					element.style.height = `${ps[3]}%` // this.Px(ps[3],this.size.h) //
				}
			}
			//alert(`SetCoord ${element.id} ${coord} ${this.size.w} ${this.size.h} ${element.style.width} ${element.style.height}`)
		}
	}

	Refresh() {
		this.coords = []
		this.items.forEach((item) => {
			let ibcr = item.getBoundingClientRect()
			this.coords.push(ibcr)
		})
	}

	InitStyle(layouts) {
        if(layouts.length>0 && this.items.length>0) {
			this.coords = []
			for (let i = 0; i < this.items.length; i++) {
				var item = this.items[i]
				let layout = layouts.find(l => l.Name===item.id)
				if(layout) {
					//alert(JSON.stringify(layout))
					this.SetCoord(item, layout.Coord)
					this.SetColor(item, layout.Color)
					this.SetFont(item, layout.Font)
				}
			}
			this.Refresh()
        }
	}

	// override methods
	selectorAll() {
		this.items = []
		if(this.root){
			this.entity = document.getElementById(this.root)
			if(this.entity) {
				this.items = this.entity.querySelectorAll(`[id^=${this.category}]`)

				let bcr = this.entity.getBoundingClientRect()
				this.size = {w:bcr.width, h:bcr.height}
	
				this.Refresh()
	
				//alert(`selectorAll ${this.entity} ${this.root} size= ${this.size.w} ${this.size.h}`)
			}
			//alert(this.items.length)
		}
		else
			this.items = document.querySelectorAll(`[id^=${this.category}]`)
	}

	mouseDown(event) {
		this.clic = {x:event.clientX, y:event.clientY}
		if(event.buttons === 1) {
			if(this.hovered>-1) {
				this.selected=this.hovered
				splitting=true
				this.items[this.selected].style.border = "1px solid gray"
			}
		}
	}

	mouseMove(event) {
		if(event.buttons === 1) {
			if(this.selected>-1 && this.selected<this.items.length) {
				if(	this.vertical ) {
					let dw = (event.clientX - this.clic.x)
					if(dw!==0) {
						if(this.selected+1<this.items.length) {
							let sides = (this.coords[this.selected].width+this.coords[this.selected+1].width)*100/this.size.w

							let nw = ((this.coords[this.selected].width + dw)*100)/this.size.w
			
							this.items[this.selected].style.width = nw + '%'
							this.items[this.selected+1].style.width = (sides-nw)+'%'
						}
						else {
							let nw = ((this.coords[this.selected].width + dw)*100)/this.size.w
			
							this.items[this.selected].style.width = nw + '%'
						}
						this.moved=true	

						window.dispatchEvent(new Event('resize'))
					}
				}
				else {
					let dh = (event.clientY - this.clic.y)
					if(dh!==0) {
						let sides = (this.coords[this.selected].height+this.coords[this.selected+1].height)*100/this.size.h

						let nh = ((this.coords[this.selected].height + dh)*100)/this.size.h
		
						this.items[this.selected].style.height = `${nh}%`
						this.items[this.selected+1].style.height = `${(sides-nh)}%`	
						this.moved=true	
						
						//window.dispatchEvent(new Event('resize')) 
					}

				}
			}
		}
		else {
			this.Bounding(event)
		}
	}

	Bounding(event) {
		this.hovered = -1
		//alert(this.items.length)
		for (var i = 0; i < this.items.length; i++) {
			this.items[i].style.cursor="pointer";
			let bcr = this.items[i].getBoundingClientRect()
			if( this.mouseIn(event, bcr) ) {
				if(	this.vertical ) {
					if((bcr.right - event.clientX)<5) {
						this.hovered=i
						//this.width=bcr.width
						this.items[i].style.cursor="e-resize"	
					}
				}
				else {
					if((bcr.bottom - event.clientY)<5) {
						this.hovered=i
						//this.height=bcr.height
						this.items[i].style.cursor="n-resize"	
					}
	
				}
			}
			//Etat(`Bounding ${this.category} resizing=${resizing} hovered=${this.hovered} selected=${this.selected} (right ${bcr.right} x ${event.clientX}) (bcr.bottom ${bcr.bottom} y ${event.clientY})`)
		}
	}

	mouseUp(event) {
		if(splitting && this.selected>-1) {
			this.items[this.selected].style.border = "0px solid gray"
			if(this.moved) {
				this.items.forEach((item) => {
					this.PutCoord(item, true)
				})
				this.Refresh()
			}
			event.stopPropagation()
			this.mouseInit(event)
		}
	}

}

export class meResults extends meSplitter {
	constructor(entityName) {
		// alert(entityName)
		super("th", entityName)
		this.selectorAll()
		this.direction = "lrt"
		this.side = -1
	}

	selectorAll() {
		this.items = []
		this.entity = document.getElementById(this.root+"Table")
		if(this.entity) {
			this.direction = getComputedStyle(this.entity).direction
			//alert(this.direction)
			//alert(`selectorAll ${this.category} ${this.root}`)
			this.items = this.entity.querySelectorAll(this.category)

			let bcr = this.entity.getBoundingClientRect()
			this.size = {w:bcr.width, h:bcr.height}

			this.Refresh()
		}
	}

	SetCoord(layout) {
		let ps = layout.Coord?.split(',')
		if(this.size && ps?.length===4) {
			let w = Math.round(ps[2]*this.size.w/100)
			const sw = `${w}px`
			//const sw = `${ps[2]}%` 
			this.items.forEach((item,index) => {
				//alert(`${item.id} - ${layout.Name} - ${layout.Coord}`)
				if(item?.id===layout.Name || item.innerHTML===layout.Name) {
					item.style.width = sw
					if(this.entity?.rows?.length>0) {
						for(let r=0; r<this.entity.rows.length; r++) {
							this.entity.rows[r].cells[index].style.width = sw
						}
					}
					this.SetColor(item, layout.Color)
					this.SetFont(item, layout.Font)
					//	alert(`Style ${sw} ${layout.Color.Back} ${layout.Font.Size}`)
					return 
				}
			})
		}
	}

	InitStyle(layouts) {
		this.selectorAll() 
		if(layouts?.length>0) {
			layouts.forEach((layout) => {
				//console.log(item)
				this.SetCoord(layout) // Id, Name, Coord, Font, Color
			})
			//alert(`InitStyle ${this.root} ${this.items.length} ${layouts.length}`)
		}
	}

	mouseDown(event) {
		this.clic = {x:event.clientX, y:event.clientY}
		if(event.buttons === 1) {
			if(this.hovered>-1) {
				this.selectorAll()

				this.selected=this.hovered
				this.side = (this.direction==='rtl') ? this.selected-1 : this.selected+1
				this.items[this.selected].style.border = "0 solid rgb(139, 194, 218)"

				resizing=true
				//alert(`meResults ${this.selected} / ${this.items.length} widths=${this.size.w} ${resizing}`)
			}
		}
	}

	mouseMove(event) {
		if(event.buttons === 1) {
			if(this.selected>-1 && this.selected<this.items.length) {
				let dw = (event.clientX - this.clic.x)
				if(dw!==0) {
					let cw = ((this.coords[this.selected].width + dw)*100)/this.size.w	
					this.items[this.selected].style.width = `${cw}%`

					if(this.entity && this.entity.rows?.length>0) {
						for(let r=0; r<this.entity.rows.length; r++) {
							this.entity.rows[r].cells[this.selected].style.width = `${cw}%`
						}
					}

					if(this.selected+1<this.items.length) {
						let nw = ((this.coords[this.selected+1].width - dw)*100)/this.size.w
						this.items[this.selected+1].style.width = `${nw}%`

						if(this.entity && this.entity.rows?.length>0) {
							for(let r=0; r<this.entity.rows.length; r++) {
								this.entity.rows[r].cells[this.selected+1].style.width = `${nw}%`  
							}
						}
					}
	
					//Etat(`Resizing ${resizing} clic.x ${this.clic.x} dw=${dw} cw=${cw} nw=${nw} size=${this.size.w} selected=${this.selected}`)
	
					this.moved=true	
				}
			}
		}
		else {
			this.Bounding(event)
		}
	}

	Bounding(event) {

		const thead = this?.entity?.querySelector('thead')
		if(thead) {
			let bcr = thead.getBoundingClientRect()
			if( this.mouseIn(event, bcr) ) {
				super.Bounding(event)
			}
		}
	}

	PutCoord(item) {
		if(item) {
			let component = item.getAttribute("entity") ?? this.root
			let element = item.getAttribute("id") ?? item.innerHTML
			let w = parseFloat(item.style.width).toFixed(2) 
			let coord = `${0},${0},${w},${1}` 

			const data = {action:'Coord', component, element, coord}
			//alert(`${data.component} ${data.element} ${data.coord}`)
			Fetch(`/Layout`,data,item,'PUT')
		}
	}

	mouseUp(event) {
		if(resizing && this.selected>-1 && this.selected<this.items.length) {
			if(this.moved) {
				//alert(`meResults ${this.selected} / ${this.items.length}`)
				this.PutCoord(this.items[this.selected])
				if(this.selected+1<this.items.length)
					this.PutCoord(this.items[this.selected+1])
			}
			//event.preventDefault()
			event.stopPropagation()
			this.mouseInit(event)
		}
	}
}

function OnVisibility(id, status=true){
	const item = document.getElementById(id)
	if(item) {
		if(status) {
			item.style.visibility='visible'
			item.style.width='auto'		
		}
		else {
			item.style.visibility='hidden'
			item.style.width=0		
		}
	}
}

function GetToken() {
	//alert("GetToken "+Api.defaults.service)
	let item = localStorage.getItem(Api.defaults.service)
	let store = item ? JSON.parse(item) : null
	return store?store.token:null
}

function OnRedirect(url, action='', id=0) {

	let token = GetToken()
	//console.log(data, token)
	
	if(token) {
		let data = JSON.stringify({'action': action, 'id': id})

		fetch(url, {
		method: 'GET',  
		redirect:'follow',
		headers: new Headers({
			'Authorization': `Bearer ${token}`
		})
		//,body: data
		}) 
		.then((response) => {
			//console.log(response); alert(response.url)
			window.location.href = response.url 
		})
		.catch((error) => {
			console.log(error)
		})
	}
	else { 
		console.log('? Unauthorized ?')
	}
}


/**
 * MeR 231103 
 */
function Historizing(component, element, field, value, entityId) {

    if(Monitoring()) {    
        GetEntityId(component,element,field)
        .then((res)=>{
            if(res?.message?.startsWith("Field")) {
                //  console.log(res.Id); alert(`Historize ${component} ${element} ${field} ${res.Id} ${value} ${entityId}`)
                var data = new FormData()
                data.append('FieldId', res.Id)
                data.append('Value', value)
				data.append('EntityId', entityId)
                Create('HistoryFields', data)
            }
        })
    }
}

/**
 * MeR 231109 
 */
function GetEntityId(component, element, field="None") {

	return new Promise(function (resolve, reject) {
        let data = JSON.stringify({'component': component, 'element': element, 'category': 7, 'field': field})
        //console.log("data",data)
    
        var xmlhttp=new XMLHttpRequest()
        xmlhttp.onreadystatechange = function() {
            if(xmlhttp.readyState === 4) {	
                let response = xmlhttp.responseText
                //console.log(response)
                if (response.includes('Id')) {
                    let item = JSON.parse(response)
                    //alert(item.Id)
                    resolve(item)
                }
                else {
                    reject({
                        status: 404,
                        response: xmlhttp.responseText
                    })
                }
            }
        }
        xmlhttp.open("POST", `${Api.defaults.baseURL}/tracking/entity`, true)
        xmlhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
        xmlhttp.send(data)
	})
}

function Create(entity, data)
{
    if (window.XMLHttpRequest) {

        data.append('entity', entity)
        data.append('action', 'Create')

        var request=new XMLHttpRequest()
        request.open("POST", "admin", true)

        let token = GetToken()
        if(token) {
            request.setRequestHeader("Authorization", `Bearer ${token}`)
		}
		
		//console.log("Create",entity,data); alert(entity+" "+token)
		request.onreadystatechange = function() {  
            if(request.readyState === 4) {
                //console.log("Create readyState", request.responseText, request); alert(entity+" "+token)
                let response = request.responseText
                if(request.status === 201) { 
                    //	location.reload()
                }
                else if(request.status === 401) { 
                    console.log(response)
                }	
            }
        }
        request.send(data)
    }
    else {
        console.log("? XMLHTTPRequest not suported ?")
    }   
}

// MeR 231126 1611
function Delete(entity, data)
{
	data.append('entity', entity)
	data.append('action', 'Delete')

	var request=new XMLHttpRequest()
	request.open("POST", "admin", true)

	let token = GetToken()
	if(token) {
		request.setRequestHeader("Authorization", `Bearer ${token}`)
	}
	
	request.onreadystatechange = function() {  
		if(request.readyState === 4) {
			if(request.status >= 400) { 
				let response = request.responseText
				console.log(response)
			}	
		}
	}
	request.send(data)
}

/**
 * MeR 231123 1819 To Test 
 */

function Monitoring() {
	let host = document.location.host 
    if( ['tajwyd.akademy.ma','moshaf.akademy.ma','math.akademy.ma','python.akademy.ma','ai.akademy.ma','app.2us.ma','tech2us.ma'].includes(host)) {
		return true
	}
	else if(host.endsWith(".1ai.ma") || host.endsWith(".2us.ma") || host.endsWith(":3000") ) {
		return true
	}
}

// MeR after item.innerHTML = response
function AppendScript(item, script) {
    const child = document.createElement('script')
    child.type = 'text/javascript'
    child.src = script
    item.appendChild(child)
}
